// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React from 'react'
import PropTypes from 'prop-types'
import { Mutation } from 'react-apollo'

import {
  Button,
  LabelledDetail,
  FixedTextInput as ContributionAmountInput
} from '../'

import { showAsCurrency } from '../../utils'

import { MUTATION_CLIENTINVESTMENT } from '../../mutations'


export class ClientInvestmentEdit extends React.PureComponent {
  static propTypes = {
    clientInvestment: PropTypes.object.isRequired,
    employerContributionEditOnly: PropTypes.bool,
    onChangeSuccess: PropTypes.func.isRequired
  }

  static defaultProps = {
    employerContributionEditOnly: true
  }

  state = {
    editMode: false,
    clientContribution: this.props.clientInvestment.currentClientContribution,
    employerContribution: this.props.clientInvestment.currentEmployerContribution
  }

  handleClientContributionChange = (e) => {
    let clientContribution = e.target.value

    this.setState({ clientContribution })
  }

  handleEmployerContributionChange = (e) => {
    let employerContribution = e.target.value

    this.setState({ employerContribution })
  }

  toggleEditMode = () => (
    this.setState(prevState => ({ editMode: !prevState.editMode }))
  )

  save = (clientinvestmentMutate) => {
    const clientInvestment = this.props.clientInvestment

    const input = {
      id: clientInvestment.id
    }

    if (clientInvestment.currentEmployerContribution !== this.state.employerContribution) {
      input.methodCall = 'set_employer_contribution'
      input.methodParams = JSON.stringify({
        amount: this.state.employerContribution,
        "product_name": clientInvestment.employerproduct.product.name
      })
    }

    clientinvestmentMutate({ variables: { input } })
      .then(this.props.onChangeSuccess)
  }

  render() {
    return (
      <div className='slds-grid slds-p-bottom_medium' style={{ alignItems: 'center', justifyContent: 'space-between' }}>
        {!this.props.employerContributionEditOnly &&
          <div className='u-font-size-larger'>
            <LabelledDetail
              label='Client contribution'
              detail={
                this.state.editMode
                  ? <ContributionAmountInput
                      text='R'
                      value={this.state.clientContribution || ''}
                      onChange={this.handleClientContributionChange}
                    />
                  : this.state.clientContribution
                    ? <div className='slds-p-top_xx-small slds-p-left_x-small'>
                        {showAsCurrency('R', this.state.clientContribution)}
                      </div>
                    : '-'
              }
            />
          </div>
        }
        <div className='u-font-size-larger'>
          <LabelledDetail
            label='Employer contribution'
            detail={
              this.state.editMode
                ? <ContributionAmountInput
                    text='R'
                    value={this.state.employerContribution || ''}
                    onChange={this.handleEmployerContributionChange}
                  />
                : this.state.employerContribution
                  ? <div className='slds-p-top_xx-small slds-p-left_x-small'>
                      {showAsCurrency('R', this.state.employerContribution)}
                    </div>
                  : '-'
            }
          />
        </div>
        <div className='slds-m-left_medium'>
          <Button
            minWidth={100}
            onClick={this.toggleEditMode}
            marginLeft={this.props.employerContributionEditOnly
              ? 0
              : '0.25em'
            }>
            {this.state.editMode
              ? 'Cancel'
              : 'Edit'
            }
          </Button>
          {this.state.editMode &&
            <Mutation mutation={MUTATION_CLIENTINVESTMENT}>
              {clientinvestmentMutate => (
                <Button
                  type='brand'
                  minWidth={100}
                  onClick={() => this.save(clientinvestmentMutate)}
                  style={{
                    display: this.props.employerContributionEditOnly
                      ? 'inline'
                      : 'block',
                    marginTop: this.props.employerContributionEditOnly
                      ? 0
                      : 5
                  }}>
                  Save
                </Button>
              )}
            </Mutation>
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/client-investment-edit/index.js